import { uploadMediaAPI } from 'store/api'
import { bindRequestLogic } from './utils'
import UploadMediaTypes from '../actionTypes/uploadMedia'

const uploadMedia = bindRequestLogic({
  clientFunc: uploadMediaAPI.upload,
  type: UploadMediaTypes.UPLOAD_MEDIA_REQUEST,
  successType: UploadMediaTypes.UPLOAD_MEDIA_SUCCESS,
  failType: UploadMediaTypes.UPLOAD_MEDIA_FAILED
})

export default [uploadMedia]
